import { map, flatten, omit, concat } from 'lodash'
import { http, queryString } from 'utils'

// User mutation imports.
import { SET_STAGES } from 'vx/mutations'

// User state.
const state = {
  stages: []
}

// User state getters.
const getters = {}

// User actions.
const actions = {

  getStages ({ commit }, payload) {
    return http.get(`/projects/stages`).then(response => {
      commit(SET_STAGES, response.data)

      return response
    })
  }
}

// User state mutations.
const mutations = {

  /**
  * Set the stages state.
  */
  [SET_STAGES] (state, stages) {
    state.stages = stages
  }
}

// Export our state, getters, actions, mutations, and modules.
export default {
  namespaced: true, state, getters, actions, mutations
}
